/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const Effort = {
  None: "none",
  Minimal: "minimal",
  Low: "low",
  Medium: "medium",
  High: "high",
  Xhigh: "xhigh",
} as const;
export type Effort = ClosedEnum<typeof Effort>;

export const Summary = {
  Auto: "auto",
  Concise: "concise",
  Detailed: "detailed",
} as const;
export type Summary = ClosedEnum<typeof Summary>;

export type ReasoningConfiguration = {
  effort: Effort | null;
  summary: Summary | null;
};

/** @internal */
export const Effort$inboundSchema: z.ZodNativeEnum<typeof Effort> = z
  .nativeEnum(Effort);
/** @internal */
export const Effort$outboundSchema: z.ZodNativeEnum<typeof Effort> =
  Effort$inboundSchema;

/** @internal */
export const Summary$inboundSchema: z.ZodNativeEnum<typeof Summary> = z
  .nativeEnum(Summary);
/** @internal */
export const Summary$outboundSchema: z.ZodNativeEnum<typeof Summary> =
  Summary$inboundSchema;

/** @internal */
export const ReasoningConfiguration$inboundSchema: z.ZodType<
  ReasoningConfiguration,
  z.ZodTypeDef,
  unknown
> = z.object({
  effort: z.nullable(Effort$inboundSchema),
  summary: z.nullable(Summary$inboundSchema),
});
/** @internal */
export type ReasoningConfiguration$Outbound = {
  effort: string | null;
  summary: string | null;
};

/** @internal */
export const ReasoningConfiguration$outboundSchema: z.ZodType<
  ReasoningConfiguration$Outbound,
  z.ZodTypeDef,
  ReasoningConfiguration
> = z.object({
  effort: z.nullable(Effort$outboundSchema),
  summary: z.nullable(Summary$outboundSchema),
});

export function reasoningConfigurationToJSON(
  reasoningConfiguration: ReasoningConfiguration,
): string {
  return JSON.stringify(
    ReasoningConfiguration$outboundSchema.parse(reasoningConfiguration),
  );
}
export function reasoningConfigurationFromJSON(
  jsonString: string,
): SafeParseResult<ReasoningConfiguration, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ReasoningConfiguration$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ReasoningConfiguration' from JSON`,
  );
}
